import React, { useEffect, useState } from "react";
import "./ProfilePopup.css";
import { useTranslation } from "react-i18next";
import { fetchNotifications, readAllNotifications } from "../../store/appSlice";
import { ReactComponent as ProfileIcon } from "../../assets/menu-profile-icon.svg";
import { ReactComponent as TariffIcon } from "../../assets/menu-tariff-icon.svg";
import { ReactComponent as LogoutIcon } from "../../assets/menu-logout-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { notificationsSelector, userSelector } from "../../store/selectors";
import bellIcon from "../../assets/bell.svg";
import { ReactComponent as ProfileArrow } from "../../assets/ProfileArrow.svg";
import { ReactComponent as BellIcon } from "../../assets/bell.svg";
import Avatar from "../Avatar/Avatar";
import { useNavigate } from "react-router";
import { useAuth } from "../../context/AuthContext";

const ProfilePopup = ({}) => {
  const [shopPopup, setShowPopup] = useState(false);
  const [isHovered, setIsHovered] = useState("");
  const { logout } = useAuth();
  const dispatch = useDispatch();
  const user = useSelector(userSelector);
  const userName = user.email;
  const navigate = useNavigate();

  useEffect(() => {
    const handleClick = (e) => {
      if (
        !e.target.closest(".user-btn") &&
        !e.target.closest(".user-menu-popup")
      ) {
        setShowPopup(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <>
      <button
        className="user-btn"
        onClick={() => setShowPopup((v) => !v)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Avatar user={user} name={userName} size={24} />
        <ProfileArrow
          style={{
            color: isHovered ? "#F1F7FF" : "#717B8E",
            width: 10,
            height: 10,
            marginLeft: 8,
          }}
        ></ProfileArrow>
      </button>
      {(shopPopup && (
        <div className="user-menu-popup">
          <button
            className="user-menu-item"
            onClick={() => {
              setShowPopup(false);
              navigate("/profile");
            }}
          >
            <ProfileIcon style={{ marginRight: 5 }} />
            Профиль
          </button>
          <button
            onClick={() => {
              setShowPopup(false);
              navigate("/pricing");
            }}
            className="user-menu-item"
          >
            <TariffIcon style={{ marginRight: 5 }} />
            Тарифный план
          </button>
          <button className="user-menu-item" onClick={logout}>
            <LogoutIcon style={{ marginRight: 5 }} />
            Выйти
          </button>
        </div>
      )) ||
        null}
    </>
  );
};

export default ProfilePopup;
